import React, { useEffect, useState } from 'react';
import { StyledCutLegend } from './FormComponents/Form.styles';
import Column from "components/Grid/Column";
import Row from "components/Grid/Row";
import NumberField from './FormComponents/NumberField';
import FuzzySearchSelect from "../FuzzySearch/FuzzySearchSelect";
import { useDavidApi } from 'utility/DavidApi/DavidApi';

function SpecialForm() {
    const api = useDavidApi();
    const [specialItems, setSpecialItems] = useState([]);

    // Special products come from /products, which is constrained to
    // specials server-side. Typing in the field fuzzy-filters this list.
    useEffect(() => {
        if (api.specialProducts === null) {
            api.getSpecialProducts();
            return;
        }

        setSpecialItems(api.specialProducts.map(product => ({
            id: product.id,
            label: product.name,
            value: { id: product.id, name: product.name },
        })));
    }, [api.specialProducts]);

    return (
        <Row>
            <StyledCutLegend>
                <Row gutter={15}>
                    <Column width={1/2}>
                        <FuzzySearchSelect
                            label="Name"
                            name="name"
                            placeholder="Search additional work..."
                            items={specialItems}
                        />
                    </Column>

                    <Column width={1/2}>
                        <NumberField
                            label="Quantity"
                            name="quantity"
                        />
                    </Column>
                </Row>
            </StyledCutLegend>
        </Row>
    )
  }

export default SpecialForm;